module.exports = __webpack_public_path__ + "media/images/flags/4x3/imn-3d2e63e176cba618f3967cdc5f5539fb.svg";